module.exports = __webpack_public_path__ + "img/shopee.ff0f63d7.svg";